import { render, staticRenderFns } from "./VeicoloStoricoForm.vue?vue&type=template&id=bab59e44"
import script from "./VeicoloStoricoForm.vue?vue&type=script&lang=js"
export * from "./VeicoloStoricoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports